<div class="success-modal-container">
  <div class="success-content">
    <!-- Success Icon -->
    <div class="success-icon">
      @if(title==='Hold on a moment!'){
      <svg xmlns="http://www.w3.org/2000/svg" width="44.69" height="40" viewBox="0 0 35 32">
        <g fill="#f05151" stroke-width="1" stroke="#f05151">
          <path
            d="M21.799 2.954C20.694 1.05 19.19 0 17.564 0s-3.131 1.05-4.236 2.954L1.059 24.087c-1.12 1.947-1.24 3.969-.33 5.546c.866 1.5 2.565 2.363 4.664 2.367h24.342c2.102-.004 3.804-.864 4.667-2.361c.905-1.567.783-3.581-.335-5.525zm11.738 26.185c-.681 1.18-2.067 1.858-3.804 1.861H5.394c-1.731-.003-3.115-.684-3.799-1.867c-.727-1.26-.606-2.917.33-4.546L14.193 3.456C15.112 1.872 16.309 1 17.564 1s2.452.872 3.37 2.456l12.268 21.157c.935 1.626 1.057 3.276.335 4.526" />
          <path
            d="M17.564 20a.5.5 0 0 0 .5-.5v-10a.5.5 0 0 0-1 0v10a.5.5 0 0 0 .5.5m-.064 2.5c-1.103 0-2 .897-2 2s.897 2 2 2s2-.897 2-2s-.897-2-2-2m0 3a1.001 1.001 0 0 1 0-2a1.001 1.001 0 0 1 0 2" />
        </g>
      </svg>


      }
      @else{
        @if(title != 'Confirm'){
      <img src="../../../../../../../assets/gifs/success-green.gif" alt="Success Icon" width="70" height="70" />

        }

      }
    </div>

    <!-- Title -->

    @if(title==='Hold on a moment!'){
    <h2 class="close-title">{{ title }}</h2>
    <p class="success-message">{{ message }}</p>



    }
    @else { <h2 class="success-title">{{ title }}</h2>
    <p class="success-message">{{ message }}</p>

    }

    <!-- Message -->

    <!-- Continue Button -->
    <div class="button-container  d-flex justify-content-end gap-0-1">
      <button class="secondaryBtn" (click)="onExit()" *ngIf="title!='Success!'"> {{exitButtonText}}</button>
      <button class="primaryBtn" (click)="onContinue()">
        {{continueButtonText}}
      </button>

    </div>
  </div>
</div>